import type { SettingResponse } from '@api/generated/types.gen';

/** Тип значения настройки из API (`STRING | INT | LONG | BOOLEAN`). */
export type SettingType = SettingResponse['type'];

/**
 * Числовые типы настроек: редактируются через `InputNumber`,
 * в списке выделяются акцентным (янтарным) цветом.
 */
export function isNumericType(type: SettingType): boolean {
  return type === 'INT' || type === 'LONG';
}

/** Цвет AntD `Tag` для бейджа типа настройки. */
export function settingTypeTagColor(type: SettingType): string {
  if (isNumericType(type)) return 'orange';
  if (type === 'BOOLEAN') return 'blue';
  return 'default';
}
